import React, {useEffect} from "react";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import useDeliveryPrice from "./useDeliveryPrice";

export default function () {
  const {handleSubmit, setErrors, deliveryPriceFields, setData} = useDeliveryPrice();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('delivery-prices/create').then(res => {
      setData(res.data.data);
    });
  }, []);

  const addPrice = data => {
    axios.post('delivery-prices', data).then(function (res) {
      navigate('/delivery-prices');
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      }
    });
  }

  return (
    <Card title="Add">
      <form className="form w-100 row" onSubmit={handleSubmit(addPrice)}>
        {deliveryPriceFields}

        <div className="col-12">
          <SubmitButton
            title="Add"
            classes="d-inline-block w-auto"
          />
        </div>
      </form>
    </Card>
  );
}